import { useSetState } from '@domain-group/react-hooks'

import { Button, Form, Image } from '@domain-group/suit-theme'

import TaskImageUpload from '@components/TaskImageUpload'

import useOrderItemTask from '@hooks/useOrderItemTask'

import { OrderItemTaskModel } from '@models/types'

const defaultState = {
  showReplaceImageUpload: false,
}

interface TaskInstallationImageProps {
  fullWidth?: boolean,
  orderItemTask: OrderItemTaskModel,
}

const TaskInstallationImage = (props: TaskInstallationImageProps) => {
  const { fullWidth, orderItemTask } = props

  const [state, setState] = useSetState(defaultState)
  const { showReplaceImageUpload } = state

  const taskPayload = useOrderItemTask(orderItemTask)
  const {
    callbacks: {
      hydrateOrderItemTask: hydrateFn,
    },
    orderItemTask: {
      instruction_image,
    },
  } = taskPayload

  const width = fullWidth ? '100%' : '188px'

  return (
    <Form.Field label="Installation Image">
      {!!instruction_image && !showReplaceImageUpload && (
        <Image
          boxProps={{
            alignItems: 'flex-end',
            borderRadius: 5,
            justifyContent: 'flex-end',
            padding: 'large',
          }}
          height={fullWidth ? 160 : 94}
          width={width}
          url={instruction_image?.large}
        />
      )}

      {(!instruction_image || showReplaceImageUpload) && (
        <TaskImageUpload
          callbacks={{
            afterAction: (response) => {
              hydrateFn(response.body)
              setState({ showReplaceImageUpload: false })
            },
          }}
          height="140px"
          orderItemTask={orderItemTask}
        />
      )}

      {!!instruction_image && (
        <Button
          buttonStyle="secondaryUtility"
          // @ts-expect-error
          marginTop="medium"
          onClick={() => setState({ showReplaceImageUpload: !showReplaceImageUpload })}
          style={{ width: showReplaceImageUpload ? undefined : width }}
          size="medium"
        >
          {showReplaceImageUpload ? 'Cancel' : 'Change Image'}
        </Button>
      )}
    </Form.Field>

  )
}

export default TaskInstallationImage
